import React from 'react';
import { twMerge } from 'tailwind-merge';
import { InfoTip } from './InfoTip';
import { MetricInfoButton } from '../definitions/MetricInfoButton';
interface PanelProps {
  title?: string;
  subtitle?: React.ReactNode;
  info?: React.ReactNode;
  definitionId?: string;
  actions?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  bodyClassName?: string;
  id?: string;
}
export function Panel({
  title,
  subtitle,
  info,
  definitionId,
  actions,
  children,
  className,
  bodyClassName,
  id
}: PanelProps) {
  return <section id={id} className={twMerge('rounded-lg border border-line bg-white', className)} data-id="element-726" data-mp="2bl52xvglsi45">
      {(title || actions) && <header className="flex flex-wrap items-start justify-between gap-3 border-b border-line px-5 py-3.5" data-id="element-727" data-mp="1wstems94zq0j">
          <div className="min-w-0" data-id="element-728" data-mp="1ntzlxcyxfjs9">
            <div className="flex items-center gap-1.5" data-id="element-729" data-mp="1nv0yjlvlcec3">
              <h2 className="text-[15px] font-semibold text-navy" data-id="element-730" data-mp="1st2tb42dq23e">{title}</h2>
              {definitionId && <MetricInfoButton id={definitionId} label={title ?? 'metric'} data-id="element-731" data-mp="1suvpfpfd93x5" />}
              {info && <InfoTip content={info} align="left" width={320} data-id="element-732" data-mp="2hfet54qjffxt" />}
            </div>
            {subtitle && <p className="mt-0.5 text-xs text-ink-muted" data-id="element-733" data-mp="2ddtaf2rbo7fp">{subtitle}</p>}
          </div>
          {actions && <div className="flex flex-wrap items-center gap-2" data-id="element-734" data-mp="2r9f5nro5fngk">{actions}</div>}
        </header>}
      <div className={twMerge('p-5', bodyClassName)} data-id="element-735" data-mp="2mabyo1olz75y">{children}</div>
    </section>;
}